export const MIXPANEL_FEATURE_FLAG_CONTROL_VARIANT = 'control' as const

/**
 * Mixpanel experiment–backed flags use unique keys per project (suffix after creation).
 * Prod / test align with `isTestEnvironment` in `landing/src/environment.ts` (same token split as `tracking.ts`).
 */
export const MIXPANEL_FEATURE_FLAG_DEFINITIONS = {
    landing_direct_conversion: {
        flagIds: {
            production: 'landing_direct_conversion',
            test: 'landing_direct_conversion',
        },
        variants: [MIXPANEL_FEATURE_FLAG_CONTROL_VARIANT, 'treatment'] as const,
    },
} as const

export type MixpanelFeatureFlagKey = keyof typeof MIXPANEL_FEATURE_FLAG_DEFINITIONS

export type MixpanelFeatureFlagVariant<K extends MixpanelFeatureFlagKey> =
    (typeof MIXPANEL_FEATURE_FLAG_DEFINITIONS)[K]['variants'][number]
